import { H1, Image } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledImage = styled(Image)`
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    min-width: 346px;
  }
`;

export const StyledHeading = styled(H1)`
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    font-size: 3rem;
    line-height: 4rem;
  }
`;
